import * as React from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { cn } from '@/lib/utils';
import { controlHeight, type ControlDensity } from './input';

/* A native <select> in the house control styling (the invoices page select, as a component): the form
 * control height (`density`, see input.tsx), the form-control border (--input, 3:1 by contract), card
 * surface, a chevron icon. Native on purpose (analysis P5): keyboard and screen-reader behaviour come from
 * the browser, and jsdom can drive it. */
export interface NativeSelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  density?: ControlDensity;
}

export const NativeSelect = React.forwardRef<HTMLSelectElement, NativeSelectProps>(function NativeSelect(
  { className, children, density = 'dense', ...props },
  ref,
) {
  return (
    <div className={cn('relative', className)}>
      <select
        ref={ref}
        className={cn(
          'w-full appearance-none rounded-md border border-input bg-card pr-9 pl-3 text-foreground',
          controlHeight(density),
          'disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive',
        )}
        {...props}
      >
        {children}
      </select>
      <ChevronDownIcon
        className="pointer-events-none absolute top-1/2 right-3 size-4 -translate-y-1/2 text-ink-muted"
        aria-hidden
      />
    </div>
  );
});
